module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_9006.5109b375.png";